<patron-form [formGroup]="formGroup" (onSubmit)="submit($event)">
  <patron-toolbar>
    <div class="container">
      <div class="flex justify-content-end">
        <patron-button type="submit" iconName="bi-check-lg" [loading]="loading">
          Alterar
        </patron-button>
      </div>
    </div>
  </patron-toolbar>

  <div class="container">
    <div class="card">
      <div class="card-body">
        <patron-tabview [tabs]="[{ header: 'Alterar senha', template: tab }]">
          <ng-template #tab>
            <div class="row d-flex justify-content-center py-5">
              <div class="col-xl-5 col-lg-6 col-md-8">
                <patron-form-field
                  label="Email"
                  [formGroup]="formGroup"
                  formControlName="userEmail">
                </patron-form-field>

                @if (!user?.is_temp_password && !user?.temp_password) {
                  <patron-form-field
                    type="password"
                    label="Senha atual"
                    [formGroup]="formGroup"
                    formControlName="currentPassword">
                  </patron-form-field>
                }

                <patron-form-field
                  type="password"
                  label="Nova senha"
                  [formGroup]="formGroup"
                  formControlName="newPassword">
                </patron-form-field>

                <patron-form-field
                  type="password"
                  label="Digite a senha novamente"
                  [formGroup]="formGroup"
                  formControlName="confirmPassword">
                </patron-form-field>
              </div>
            </div>
          </ng-template>
        </patron-tabview>
      </div>
    </div>
  </div>
</patron-form>
